export enum RestaurantDraftStatus {
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}
